/* eslint-disable react/prop-types */
import React from "react";

function Dragdrop({ children, id, draggable, changeHierarchy }) {
  const dragStartHandler = (event) => {
    event.dataTransfer.setData("text/plain", JSON.stringify(event.target.id));
  };
  const dragOverHandler = (event) => {
    event.preventDefault();
  };
  const dropHandler = (event) => {
    const origin = JSON.parse(event.dataTransfer.getData("text/plain"));
    const destination = event.currentTarget.id;
    const [prefixO, originId] = origin && origin.split("-");
    const [prefixD, destinationId] = destination && destination.split("-");

    if (prefixO === "subChild" && prefixD === "child") {
      changeHierarchy(originId, destinationId);
    }
  };

  return (
    <div
      draggable={draggable ? "true" : undefined}
      onDragStart={dragStartHandler}
      onDragOver={dragOverHandler}
      onDrop={dropHandler}
      //   style={{ backgroundColor: "red" }}
      id={id}
    >
      {children}
    </div>
  );
}

export default Dragdrop;
